export default function AnalyticsTab({ analytics }) {
  if (!analytics) return <div className="text-sm text-[#3D2817]/50">Loading…</div>;
  const stats = [
    { label: 'Catalog Views', val: analytics.totals.catalog_views_30d },
    { label: 'Product Views', val: analytics.totals.product_views_30d },
    { label: 'Total Views', val: analytics.totals.views_30d },
    { label: 'Quote Requests', val: analytics.totals.quotes_30d },
  ];
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-serif">Analytics <span className="text-sm text-[#3D2817]/50 font-sans">— last 30 days</span></h2>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        {stats.map(s => (
          <div key={s.label} className="border rounded-sm p-6 bg-white">
            <div className="text-xs uppercase tracking-widest text-[#3D2817]/50 mb-2">{s.label}</div>
            <div className="font-serif text-4xl">{s.val}</div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="border rounded-sm p-6">
          <h3 className="font-serif text-lg mb-4">Top Products by Views</h3>
          {analytics.top_products.length === 0 && <div className="text-sm text-[#3D2817]/50">No product views yet.</div>}
          <ul className="space-y-2">
            {analytics.top_products.map(p => (
              <li key={p.product_id} className="flex justify-between items-center py-2 border-b border-[#E5D9C8] last:border-0">
                <div>
                  <div className="text-xs text-[#3D2817]/50 font-mono">{p.sku}</div>
                  <div className="font-serif">{p.name}</div>
                </div>
                <div className="font-serif text-xl text-[#C5A059]">{p.views}</div>
              </li>
            ))}
          </ul>
        </div>
        <div className="border rounded-sm p-6">
          <h3 className="font-serif text-lg mb-4">Countries (from Quotes)</h3>
          {analytics.countries.length === 0 && <div className="text-sm text-[#3D2817]/50">No quotes yet.</div>}
          <ul className="space-y-2">
            {analytics.countries.map(c => (
              <li key={c.country} className="flex justify-between items-center py-2 border-b border-[#E5D9C8] last:border-0">
                <span>{c.country}</span>
                <span className="font-serif text-xl text-[#C5A059]">{c.quotes}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="border rounded-sm p-6">
          <h3 className="font-serif text-lg mb-4">Language Preferences</h3>
          {analytics.languages.length === 0 && <div className="text-sm text-[#3D2817]/50">No data yet.</div>}
          <ul className="space-y-2">
            {analytics.languages.map(l => (
              <li key={l.lang} className="flex justify-between items-center py-2 border-b border-[#E5D9C8] last:border-0">
                <span className="uppercase text-xs tracking-widest">{l.lang}</span>
                <span className="font-serif text-xl text-[#C5A059]">{l.views}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="border rounded-sm p-6">
          <h3 className="font-serif text-lg mb-4">Views — Last 14 Days</h3>
          {analytics.trend.length === 0 && <div className="text-sm text-[#3D2817]/50">No data yet.</div>}
          <div className="space-y-1">
            {analytics.trend.map(d => {
              const max = Math.max(...analytics.trend.map(x => x.views), 1);
              return (
                <div key={d.date} className="flex items-center gap-3 text-xs">
                  <span className="w-20 text-[#3D2817]/50">{d.date.slice(5)}</span>
                  <div className="flex-1 h-4 bg-[#F2ECE0] rounded-sm overflow-hidden">
                    <div className="h-full bg-[#C5A059]" style={{ width: `${(d.views/max)*100}%` }} />
                  </div>
                  <span className="w-8 text-right">{d.views}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
